exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ad-page-parent[data-v-5c024949]{border:1px solid #000;height:297px;width:180px;background:#ebebeb;position:relative}.v--modal-overlay[data-v-5c024949]{z-index:1000}.modal-header .fa-times[data-v-5c024949]{cursor:pointer}", ""]);

// exports
